import React from 'react';
import { Box, useTheme } from '@mui/material';
import { Accordion, ReactGridContainer } from '@europrocurement/flexy-components';

import TasksDashboardWidget from '../../components/TasksDashboardWidget/TasksDashboardWidget';
import NotificationWidgetDashboard from '../../components/NotificationWidgetDashboard/NotificationWidgetDashboard';

type FormalistDashboardProps = {
    title: string;
    userId: number;
};

const InternDashboard: React.FunctionComponent<FormalistDashboardProps> = function ({
    title,
    userId,
}) {
    const { palette } = useTheme();

    return (
        <Accordion
            title={title}
            expandLabel
            expanded
            expandColor={palette.secondary}
            sx={{ boxShadow: 'unset', border: 'none' }}
            contentSxProps={{ gap: '16px', display: 'grid' }}
        >
            <ReactGridContainer
                localStorageName="grid-intern-user"
                gridconfig={{ cols: 12, rowHeight: 30 }}
                layoutProps={[
                    {
                        i: 'list-tasks-intern',
                        x: 0,
                        y: 0,
                        w: 6,
                        h: 16,
                        isResizable: true,
                        resizeHandles: ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'],
                    },
                    {
                        i: 'list-messages-user',
                        x: 6,
                        y: 0,
                        w: 6,
                        h: 16,
                        isResizable: true,
                        resizeHandles: ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'],
                    },
                ]}
            >
                <Box
                    key="list-tasks-intern"
                    sx={{
                        background: palette.background.paper,
                        borderRadius: '8px',
                        padding: '0px 8px',
                    }}
                >
                    <TasksDashboardWidget formalistIds={[userId]} />
                </Box>
                <Box
                    key="list-messages-user"
                    sx={{
                        background: palette.background.paper,
                        borderRadius: '8px',
                        padding: '0px 8px',
                        height: '100%',
                        overflow: 'auto',
                    }}
                >
                    <NotificationWidgetDashboard />
                </Box>
            </ReactGridContainer>
        </Accordion>
    );
};

export default InternDashboard;
